import { zodResolver } from '@hookform/resolvers/zod';

export const debugResolver =
  (schema: any) => async (data: any, context: any, options: any) => {
    // you can debug your validation schema here
    console.log('formData', data);
    console.log(
      'validation result',
      await zodResolver(schema)(data, context, options),
    );
    return zodResolver(schema)(data, context, options);
  };

export function getErrorMessage(error: string | Error | undefined): string {
  if (error === undefined) {
    return '';
  } else if (typeof error === 'string') {
    return error;
  }

  return error.message;
}
